import { DisplayMessage } from './display-message';
import { DisplayMessageFile } from './display-message-file';

export class DisplayMessageFileAdapter {
  static messageToMessageFile(dm: DisplayMessage): DisplayMessageFile {
    const messageFile = new DisplayMessageFile(dm.chatMessage);

    messageFile.url = '';
    messageFile.tooltip = dm.content['body'] || '';
    messageFile.isLoaded = false;
    messageFile.isValid = true;
    messageFile.blob = new Blob();

    return messageFile;
  }
}
